import script from "./NotificationPopups.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationPopups.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationPopups.vue?vue&type=style&index=0&id=0d686409&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d686409"]])

export default __exports__